export default __webpack_public_path__ + "static/1362-b5182592e5557e85c37aa13124fe3f37.gif";